export enum PageAccess {
  ADMIN,
  CLIENT,
  CLIENT_ADMIN,
  DEFAULT
}